import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

import TopHeader from "../../../components/common/Header/TopHeader";
import DoctorManagementMenu from "../../../components/common/Menu/DoctorManagement";


// Corrected imports with error handling
let DetailsTreatments, LaboratoryTreatments, NotesTreatments, DiagnosticImagingTreatments;
let MedicalRecordTreatments, TeamChatTreatments, NursingTreatments, MolecularMedicineTreatments;
let TreatmentTimelineTreatments;

try {
  DetailsTreatments = require("../Components/DetailsTreatment/DetailsTreatments").default;
} catch (e) {
  DetailsTreatments = () => <div className="alert alert-warning">DetailsTreatments component not available</div>;
}

try {
  LaboratoryTreatments = require("../Components/Laboratory/LaboratoryTreatments").default;
} catch (e) {
  LaboratoryTreatments = () => <div className="alert alert-warning">LaboratoryTreatments component not available</div>;
}

try {
  NotesTreatments = require("../Components/Notes/NotesTreatments").default;
} catch (e) {
  NotesTreatments = () => <div className="alert alert-warning">NotesTreatments component not available</div>;
}

try {
  DiagnosticImagingTreatments = require("../Components/DiagnosticImaging/DiagnosticImagingTreatments").default;
} catch (e) {
  DiagnosticImagingTreatments = () => <div className="alert alert-warning">DiagnosticImagingTreatments component not available</div>;
}

try {
  MedicalRecordTreatments = require("../Components/MedicalRecord/MedicalRecordTreatments").default;
} catch (e) {
  MedicalRecordTreatments = () => <div className="alert alert-warning">MedicalRecordTreatments component not available</div>;
}

try {
  TeamChatTreatments = require("../Components/TeamChat/TeamChatTreatments").default;
} catch (e) {
  TeamChatTreatments = () => <div className="alert alert-warning">TeamChatTreatments component not available</div>;
}

try {
  NursingTreatments = require("../Components/Nursing/NursingTreatments").default;
} catch (e) {
  NursingTreatments = () => <div className="alert alert-warning">NursingTreatments component not available</div>;
}

try {
  MolecularMedicineTreatments = require("../Components/MolecularMedicine/MolecularMedicineTreatments").default;
} catch (e) {
  MolecularMedicineTreatments = () => <div className="alert alert-warning">MolecularMedicineTreatments component not available</div>;
}

try {
  TreatmentTimelineTreatments = require("../Components/TreatmentTimeline/TreatmentTimelineTreatments").default;
} catch (e) {
  TreatmentTimelineTreatments = () => <div className="alert alert-warning">TreatmentTimelineTreatments component not available</div>;
}

const PatientTreatmentDetailList = () => {
  const location = useLocation();
  const [dataTreatments, setDataTreatments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Checkbox states
  const [activeComponents, setActiveComponents] = useState({
    treatmentDetails: true,
    laboratory: true,
    notes: true,
    diagnosticImaging: true,
    medicalRecord: true,
    teamChat: true,
    nursing: true,
    molecularMedicine: true,
    treatmentTimeline: true
  });

  // Counter states
  const [counters, setCounters] = useState({
    treatmentDetails: 0,
    laboratory: 0,
    notes: 0,
    diagnosticImaging: 0,
    medicalRecord: 0,
    teamChat: 0,
    nursing: 0,
    molecularMedicine: 0,
    treatmentTimeline: 0
  });

  // Patient data from navigation state - memoized to avoid recreation
  const patientData = useMemo(() => ({
    id: location.state?.patientId || '',
    insurance: location.state?.patientInsurance || 'Max Life Insurance',
    name: location.state?.patientName || '',
    dob: location.state?.patientDob || '',
    email: location.state?.patientEmail || '',
    phone: location.state?.patientPhone || ''
  }), [location.state]);

  // Function to update counters from child components - memoized
  const updateCounter = useCallback((componentName, count) => {
    setCounters(prev => {
      // Only update if the value has changed
      if (prev[componentName] !== count) {
        return {
          ...prev,
          [componentName]: count
        };
      }
      return prev;
    });
  }, []);

  const handleCheckboxChange = useCallback((componentName) => {
    setActiveComponents(prev => ({
      ...prev,
      [componentName]: !prev[componentName]
    }));
  }, []);

  // Function to check if all components are selected - memoized
  const areAllSelected = useMemo(() => {
    return Object.values(activeComponents).every(value => value === true);
  }, [activeComponents]);

  // Function to select/deselect all
  const handleSelectAll = useCallback(() => {
    const allSelected = areAllSelected;
    const newState = {};
    
    Object.keys(activeComponents).forEach(key => {
      newState[key] = !allSelected;
    });
    
    setActiveComponents(newState);
  }, [areAllSelected, activeComponents]);

  // Component configuration with their labels and counters - memoized
  const componentConfig = useMemo(() => [
    { key: 'treatmentDetails', label: 'Treatment Details', component: DetailsTreatments },
    { key: 'laboratory', label: 'Laboratory', component: LaboratoryTreatments },
    { key: 'notes', label: 'Notes', component: NotesTreatments },
    { key: 'diagnosticImaging', label: 'Diagnostic Imaging', component: DiagnosticImagingTreatments },
    { key: 'medicalRecord', label: 'Medical Record', component: MedicalRecordTreatments },
    { key: 'teamChat', label: 'Team Chat', component: TeamChatTreatments },
    { key: 'nursing', label: 'Nursing', component: NursingTreatments },
    { key: 'molecularMedicine', label: 'Molecular Medicine', component: MolecularMedicineTreatments },
    { key: 'treatmentTimeline', label: 'Treatment Timeline', component: TreatmentTimelineTreatments }
  ], []);

  // Effect to handle initial loading if necessary
  useEffect(() => {
    // If there's initial loading logic, put it here
    setIsLoading(false);
  }, []);

  return (
    <main id="app">
            <TopHeader />

            <div className="content_wrapper">

                <section class="patient-treatment-wrapper pb-5">
                    
                    {/* Inner Menu */}
                    <DoctorManagementMenu activeMenu='patients'/>

                    {/* Body Container */}
                    <div className="container-fluid px-lg-5 bg-light-grey">

                      {/* Breadcrumb */}
                      <nav class="breadcrumb-container d-none d-md-block pt-3 mb-2" aria-label="breadcrumb">
                          <ol className="breadcrumb fs-sm mb-0">
                            <li className="breadcrumb-item">
                              <a href="/dashboard" className="text-decoration-none">Dashboard</a>
                            </li>
                            <li className="breadcrumb-item">
                              <a href="/patients/list" className="text-decoration-none">Patients</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Treatment Details</li>
                          </ol>
                      </nav>

                  

                        {/* Patient Info Section */}
                        <ul className="d-flex align-items-center gap-3 px-3 py-2 bg-white text-nowrap rounded-8 shadow-sm overflow-x-auto mb-4">
                          {/* <li className="flex-fill">ID {patientData.id}</li> */}

                          <li className="flex-fill">{patientData.insurance}</li>
                          <li className="flex-fill d-flex align-items-center gap-2">
                            <div className="avatar rounded-circle overflow-hidden" style={{ width: "1.5rem", height: "1.5rem" }}>
                              {/* Replace with actual patient photo if available */}
                              <img src="/assets/img/dp-1.jpg" alt={patientData.name} className="w-100 h-100 object-fit-cover object-center" />
                            </div>
                            <p className="mb-0">{patientData.name}</p>
                          </li>
                          <li className="flex-fill d-flex align-items-center gap-2">
                            <span className="d-block material-symbols-outlined icon-lg text-gray">calendar_today</span>
                            <span className="d-block">
                              {/* Format DOB as dd-mm-yyyy */}
                              {patientData.dob
                                ? (() => {
                                    const date = new Date(patientData.dob);
                                    if (isNaN(date.getTime())) return patientData.dob;
                                    const dd = String(date.getDate()).padStart(2, '0');
                                    const mm = String(date.getMonth() + 1).padStart(2, '0');
                                    const yyyy = date.getFullYear();
                                    return `${dd}-${mm}-${yyyy}`;
                                  })()
                                : ""}
                            </span>
                          </li>
                          <li className="flex-fill">
                            <a href={`mailto:${patientData.email}`} className="text-decoration-none d-flex align-items-center gap-2">
                              <span className="d-block material-symbols-outlined icon-lg text-primary">email</span>
                              <span className="d-block">{patientData.email}</span>
                            </a>
                          </li>
                          <li className="flex-fill">
                            <a href={`tel:${patientData.phone}`} className="text-decoration-none d-flex align-items-center gap-2">
                              <span className="d-block material-symbols-outlined icon-lg text-primary">phone_in_talk</span>
                              <span className="d-block">{patientData.phone}</span>
                            </a>
                          </li>
                          <li className="flex-fill">
                            <img src="/assets/img/whatsapp.svg" alt="Whatsapp" className="img-fluid" />
                          </li>
                        </ul>

                        {/* Filter Section */}
                        <ul className="d-flex gap-2 overflow-x-auto mb-4 p-0">
                          {componentConfig.map((config) => (
                            <li key={config.key} className="d-flex gap-2 bg-white p-3 shadow-sm rounded-10">
                              <div className="form-check p-0 d-flex flex-fill align-items-center gap-2 fs-sm text-gray m-0 cursor-pointer rounded-8">
                                <input
                                  type="checkbox"
                                  name={config.key}
                                  id={config.key}
                                  className="form-check-input flex-shrink-0 bg-transparent border-2 border-gray-600 shadow-none m-0"
                                  checked={activeComponents[config.key]}
                                  onChange={() => handleCheckboxChange(config.key)}
                                />
                                <label
                                  className="d-block lh-1 cursor-pointer form-check-label"
                                  htmlFor={config.key}
                                >
                                  {config.label}
                                </label>
                              </div>
                              {/* Show counter badge only if > 0 */}
                              {counters[config.key] > 0 && (
                                <span
                                  className="d-flex align-items-center justify-content-center bg-danger fs-sm text-white rounded-circle"
                                  style={{ width: "1.25rem", height: "1.25rem" }}
                                >
                                  {counters[config.key]}
                                </span>
                              )}
                            </li>
                          ))}
                        </ul>

                        {/* Treatment Components in Two Columns */}
                      
                        <div className="row">
                          {componentConfig.map((config) => {
                            if (!activeComponents[config.key]) return null;
                            
                            const Component = config.component;
                            return (
                              <div key={config.key} className="col-lg-6 mb-4">
                                <Component 
                                  patientId={patientData.id} 
                                  onCountUpdate={updateCounter}
                                  componentName={config.key}
                                />
                              </div>
                            );
                          })}
                        </div>
                        

                    
                      
                    </div>
                </section>
            </div>
    </main>
  );
};

export default PatientTreatmentDetailList;